import { useState } from 'react'
import { OrgStorageVolumeCard } from './OrgStorageVolumeCard'
import { UserStorageVolumeCard } from './UserStorageVolumeCard'

export const StorageVolume = () => {
  const [orgStorageLimit, setOrgStorageLimit] = useState<number>(0)
  const [orgStorageCountLimit, setOrgStorageCountLimit] = useState<number>(0)
  return (
    <div className="space-y-8" data-testid="storage-volume-page">
      {/* Management Section */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="org-storage-volume-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="org-storage-volume-heading"
          >
            Organization Storage Limit
          </h3>
          <p className="text-sm text-muted-foreground">
            Set default storage volume for all users
          </p>
        </div>
        <div className="p-6">
          <OrgStorageVolumeCard
            onLimitChange={(limit, countLimit) => {
              setOrgStorageLimit(limit)
              setOrgStorageCountLimit(countLimit)
            }}
          />
        </div>
      </div>

      {/* User-specific storage limits */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="user-storage-volume-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="user-storage-volume-heading"
          >
            User-Specific Storage Limits
          </h3>
          <p className="text-sm text-muted-foreground">
            Override default storage volume for specific users
          </p>
        </div>
        <div className="p-6">
          <UserStorageVolumeCard
            orgStorageLimit={orgStorageLimit}
            orgStorageCountLimit={orgStorageCountLimit}
          />
        </div>
      </div>
    </div>
  )
}
